import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import red from '@material-ui/core/colors/red';


const False = () => <CancelIcon style={{ color: red[500] }} />;

export default False;
